// @ts-ignore
import type * as SchemaTypes from '../../../../graphql/api/index';

import { gql } from 'graphql-tag';
export const BlogMenuFragmentDoc = gql`
    fragment blogMenu on PostCategory {
  id
  name
  slug
  children(locale: $locale) {
    id
    name
    slug
  }
}
    `;